// File: src/components/potus/ExecutiveOrders.jsx
import React from 'react';
import { 
  Box, 
  Typography, 
  CircularProgress,
  Paper
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
// import { formatDate } from '../../utils/constants';
import TitleAndInfo from '../TitleAndInfo';
import ExecutiveOrderCard from './ExecutiveOrderCard';

const ExecutiveOrders = ({ data, loading }) => {
  const theme = useTheme();

  // Get the date from the first record if data exists
  // const dataDate = data && data.length > 0 && data[0].date 
  //   ? formatDate(data[0].date)
  //   : '';

  // const titleWithDate = dataDate 
  //   ? `Recent Executive Orders (Latest: ${dataDate})` 
  //   : 'Recent Executive Orders';

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" my={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ mb: 3, pl: 2 }}>
        <TitleAndInfo
          titleTop="Executive Actions:"
          title=""
          info="Recent executive actions signed by the President."
        />
      </Box>

      {!data || data.length === 0 ? (
        <Paper
          variant="stats"
          sx={{
            p: 4,
            textAlign: 'center',
            backgroundColor: theme.palette.mode === 'dark'
              ? 'rgba(19, 47, 76, 0.4)'
              : 'rgba(255, 255, 255, 0.8)',
            backdropFilter: 'blur(10px)',
            border: theme.palette.mode === 'dark'
              ? '1px solid rgba(255, 255, 255, 0.1)'
              : '1px solid rgba(0, 0, 0, 0.1)',
          }}
        >
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No Executive Orders Available
          </Typography>
          <Typography variant="body2" color="text.secondary">
            No executive orders data is currently available. Please check back later.
          </Typography>
        </Paper>
      ) : (
        <Box>
          {/* Executive Orders List */}
          {data.map((order, index) => (
            <ExecutiveOrderCard 
              key={order.unique_id || index} 
              order={order} 
            />
          ))}
          
          {/* Summary Footer */}
          <Paper
            variant="stats"
            sx={{
              p: 2,
              mt: 3,
              backgroundColor: theme.palette.mode === 'dark'
                ? 'rgba(19, 47, 76, 0.2)'
                : 'rgba(255, 255, 255, 0.6)',
              backdropFilter: 'blur(10px)',
              border: theme.palette.mode === 'dark'
                ? '1px solid rgba(255, 255, 255, 0.05)'
                : '1px solid rgba(0, 0, 0, 0.05)',
              textAlign: 'center'
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Showing {data.length} most recent executive orders • 
              <Typography 
                component="span" 
                variant="body2" 
                sx={{ ml: 0.5 }}
              >
                Visit whitehouse.gov for complete archive
              </Typography>
            </Typography>
          </Paper>
        </Box>
      )}
    </Box>
  );
};

export default ExecutiveOrders;